<kodit-card-container>
    <div card-title>Avansne uplate</div>
    <div card-right-side class="flex gap-2 mb-2" *ngIf="!isEditing && !jeInfoStrana">
      <button
        pButton
        label="Izmeni"
        icon="pi pi-pencil"
        class="p-button-success"
        (click)="startEdit()"
      ></button>
    </div>

    <div card-right-side class="flex gap-2 mb-2" *ngIf="isEditing">
        <button
          pButton
          label="Sačuvaj"
          icon="pi pi-check"
          class="p-button-success"
          (click)="saveChanges()"
        ></button>
        <button
          pButton
          label="Otkaži"
          icon="pi pi-times"
          class="p-button-danger p-ml-2"
          (click)="cancelEdit()"
        ></button>
    </div>
  <div card-body>
    <kodit-avansna-uplata-racuna-table #racuniTable [globalEditMode]="isEditing"></kodit-avansna-uplata-racuna-table>

    <button
      *ngIf="shouldAllowButton"
      pButton
      pRipple
      type="button"
      icon="fas fa-plus"
      class="p-button-outlined p-mt-5"
      (click)="overlayPanelRef.toggle($event)"
      label="Nova avansna uplata"
      pTooltip="Registruj avansnu uplatu na račun"
      [disabled]="ukupanIznos.value.ukupnoZaUplatu === 0"
    ></button>

    <p-overlayPanel #overlayPanelRef [showCloseIcon]="true">
      <ng-template pTemplate>
        <div class="overlay-content">
          <kodit-avansni-racun-table
            (onRegistrujUplate)="overlayPanelRef.hide()"
          >
          </kodit-avansni-racun-table>
        </div>
      </ng-template>
    </p-overlayPanel>

    <kodit-ukupan-iznos-table
      *ngIf="shouldDisplayUkupanIznos"
    ></kodit-ukupan-iznos-table>
  </div>
</kodit-card-container>
